import { createBrowserHistory } from 'react-resource-router';

// Both routers must observe navigation between the product and standalone pages.
export const appHistory = createBrowserHistory();
